exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-image-container[data-v-66ba7fce] {\n  max-height: 400px;\n}\n.product-image[data-v-66ba7fce] {\n  -o-object-fit: contain;\n     object-fit: contain;\n  max-width: 310px;\n  height: 100%;\n  width: 100%;\n}\n.sticky-bg[data-v-66ba7fce] {\n  background: rgba(255, 255, 255, 0.7);\n}\n@media screen and (min-width: 768px) {\n.sticky-bg[data-v-66ba7fce] {\n    background: none;\n}\n}\n", ""]);

// exports
